import "./Header.css";
import logo from "../../assets/IESA_Logo_25.png";
import MenuIcon from "../../assets/menu-collapsed.svg"
import userIcon from "../../assets/user.png";
import { useEffect, useState, useRef, useContext } from "react";
import { MenuContext } from "../../screens/Main";
import WebService from "../../utility/WebService";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [userName, setUserName] = useState("");
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "/login";
  };

  const menuRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target as Node)
      ) {
        setShowMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    getMe();

    const storedUser = localStorage.getItem("UserData");
    if (storedUser) {
      const localdata = JSON.parse(storedUser);
      console.log("LocalData", localdata);
      // setUserName(localdata.fullName)
    } else {
      console.log("No user data found in localStorage");
    }
  }, []);
  const getMe = () => {
    WebService.getAPI({
      action: "users/me",
    })
      .then((res: any) => {
        if (res && res?.data) {
          setUserName(res?.data.username)
          localStorage.setItem("UserData", JSON.stringify(res.data));
          localStorage.setItem("UserImage", res.data.image || "");
        }
      })
      .catch((error: any) => {
        setShowLoader(false);
      });
  };
  const { toggleMenu } = useContext(MenuContext);
  return (
    <div className="header">
      <img src={logo} alt="Logo" height={35} className="ms-3" />
      <button className="bg-transparent p-0 border-0 menu-btn" onClick={toggleMenu}><img src={MenuIcon} alt="Menu Icon" width={30} /></button>
      <div className="user-menu ms-auto me-3" style={{ position: "relative" }} ref={menuRef}>
        <button
          className="btn btn-link p-0"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            background: "#F5F5F5",
            border: "none",
            borderRadius: "9999px", // pill shape
            padding: "6px 12px",
            cursor: "pointer",
            textDecoration: "none",
          }}
          onClick={() => setShowMenu((prev) => !prev)}
        >
          <span>
            <img
              src={userIcon}
              alt="User Icon"
              style={{
                width: "32px",
                height: "32px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          </span>
          <span
            style={{
              fontSize: "13px",
              fontWeight: 600,
              color: "#000",
              whiteSpace: "nowrap",
              textDecoration: "none",
            }}
          >
            {userName}
          </span>

          {/* Chevron */}
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{
              transition: "transform 0.2s",
              transform: showMenu ? "rotate(180deg)" : "rotate(0deg)",
            }}
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </button>
        {showMenu && (
          <div
            className="dropdown-menu show"
            style={{
              position: "absolute",
              right: 0,
              top: "2.5rem",
              minWidth: "120px",
              zIndex: 1000,
            }}
          >
            <button className="dropdown-item" onClick={() => navigate('/profile')}>
              Profile
            </button>
            <button className="dropdown-item" onClick={handleLogout}>
              Logout
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
